import * as cx from 'classnames';
import {
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_PHOTO,
    CLICK_HERE_TO_ENTER_DESCRIPTION,
    GO_BACK_TO_ALBUM,
    GO_BACK_TO_AUTOMATIC_MESSAGE,
    GO_BACK_TO_GROUP_POST,
    GO_BACK_TO_SHORT_MESSAGE,
    SAVE_DESCRIPTION,
    WAS_ADDED_when,
} from 'mk/autogenerated/translations/Album.04c993eb3d1ba1dd93022ec095a0c276'
import { urlize } from 'mk/bazaar/common/filters';
import { isMqDesktop } from 'mk/common/responsive';
import { FormControls } from 'mk/forms/FormControls';
import { RawForm } from 'mk/forms/RawForm';
import { TextField } from 'mk/forms/TextField';
import { jQuery as $ } from 'mk/jQuery';
import { photoblog_photo_delete_url, photoblog_photo_rotate_url, photoblog_set_image_title_url } from 'mk/urls/functions';
import Comments from 'mk2/apps/blogs/containers/Comments/Comments';
import Emojify from 'mk2/components/Emojify';
import ImageGallery from 'mk2/components/ImageGalleryLoadable';
import { timeAt } from 'mk2/helpers/timeformat';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import ReactImageGallery from 'react-image-gallery';
import * as complaintdyn from '../complaintdyn';
import { LikeControl } from './LikeControl';
import { LikeSection } from './LikeSection';

interface Image {
    id: number;
    title: string;
    bigSrc: string;
    smallSrc: string;
    hdSrc?: string;
    url: string;
    complaintData: any;
    likeData: any;
    comment2Data: any;
    albumUrl: string;
    albumTitle: string;
    ownerUrl: string;
    ownerName: string;
    ownerAvatarImage: string;
    albumType: string;
    created: number;
    canRotate: boolean;
    canDelete: boolean;
    canEdit: boolean;
}

interface OwnProps {
    currentIndex: number;
    images: Image[];
    isAdmin?: boolean;
    isAlbumPopup?: boolean;
    imageId?: number;
}

interface State {
    startingUrl: string;
    current: number;
    images: Image[];
    showEditTitle: boolean;
    savingTitle: boolean;
    loading: boolean;
    loadingComments: boolean;
    disableKeyboard: boolean;
}

/**
 * TODO: Resolve FAKE context
 * TODO: Use one XHR library - currently this is using jQuery because mk/xhr needs context.apiAuth (because first TODO)
 */
export class Album extends React.Component<OwnProps, State> {

    public static defaultProps = {
        isAlbumPopup: false,
    };

    private root: HTMLDivElement;
    private imageGallery: ReactImageGallery;

    constructor(props, context) {
        super(props, context);

        let current = props.currentIndex;
        const images = props.images;

        // if given imageId, set current index to proper image in the album
        if (props.imageId) {
            current = 0;
            for (const image of images) {
                if (image.id === props.imageId) {
                    break;
                }
                current++;
            }
        }

        this.state = {
            startingUrl: window.location.href,
            current,
            images,
            showEditTitle: false,
            savingTitle: false,
            loading: false,
            loadingComments: false,
            disableKeyboard: false,
        };

    }

    public componentDidMount() {
        $(window).on('popstate.album', (e) => {
            const state = e.originalEvent.state;
            if (state && state.album) {
                this.imageGallery.slideToIndex(state.current);
            }
        });

        // Hack - we need to disable gallery keyboard shortcuts when there is focus
        $(this.root).on('focus.album', 'input, textarea', (e) => {
            this.setState({ disableKeyboard: true });
        });
        $(this.root).on('blur.album', 'input, textarea', (e) => {
            this.setState({ disableKeyboard: false });
        });

        // Custom events
        $(this.root).on('comment', (e, extraData) => {
            // const {current, images} = this.state;
            // const currentImage = images[current];
            // comment2.updateData(currentImage.comment2Data, extraData);
        });
        $(this.root).on('complaint', (e, data) => {
            const { current, images } = this.state;
            const currentImage = images[current];
            const modifiedComplaintData = complaintdyn.onComplaintChange(currentImage.complaintData, data);
            this.setState({
                images: [
                    ...this.state.images.slice(0, current),
                    {
                        ...this.state.images[current],
                        complaintData: modifiedComplaintData,
                    },
                    ...this.state.images.slice(0, current + 1),
                ],
            });
        });
    }

    public componentWillUnmount() {
        $(window).off('popstate.album');
    }

    public render() {
        const {isAdmin} = this.props;
        const {current, showEditTitle, savingTitle, images, disableKeyboard} = this.state;
        const currentImage = images[current];

        // FAKE context till we came with more useful solution
        const context = {};

        // TODO: Load this from some context and make it reusable
        const isAuth = (window as any).MK.requestUser.username !== 'anonymous';
        const isStaff = $('body').data('isStaff');

        const items = images.map((i) => {
            return {
                original: i.bigSrc,
                thumbnail: i.smallSrc,
            };
        });

        return (
            <div ref={(r) => { this.root = r; }}>
                {isStaff ? <span dangerouslySetInnerHTML={{__html: complaintdyn.renderReport(currentImage.complaintData)}} /> : null}

                {this.props.isAlbumPopup ? (
                    <div className="photo-info">
                        <div className="album-title">
                            <a href={currentImage.albumUrl}>
                                <Emojify>
                                    {currentImage.albumTitle}
                                </Emojify>
                            </a>
                        </div>

                        &nbsp;&nbsp;&bull;&nbsp;&nbsp;

                        <a href={currentImage.ownerUrl}>
                            <span dangerouslySetInnerHTML={{__html: currentImage.ownerAvatarImage}} />
                            &nbsp;
                            {currentImage.ownerName}
                        </a>
                    </div>
                ) : (
                    <div className="photo-info">
                        <a href={currentImage.ownerUrl}>
                            <span dangerouslySetInnerHTML={{__html: currentImage.ownerAvatarImage}} />
                            &nbsp;
                            {currentImage.ownerName}
                        </a>

                        {(currentImage.albumType !== 'automatic_message') && (
                            <span>
                                &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                                <a href={currentImage.albumUrl}>
                                    {
                                        {
                                            ALBUM: GO_BACK_TO_ALBUM,
                                            AUTOMATIC_MESSAGE: GO_BACK_TO_AUTOMATIC_MESSAGE,
                                            GROUP_POST: GO_BACK_TO_GROUP_POST,
                                            SHORT_MESSAGE: GO_BACK_TO_SHORT_MESSAGE,
                                        }[currentImage.albumType.toUpperCase()]
                                    }
                                </a>
                            </span>
                        )}
                    </div>
                )}

                <div className="gallery">
                    <ImageGallery
                        items={items}
                        startIndex={current}
                        lazyLoad
                        showIndex
                        showFullscreenButton={false}
                        showPlayButton={false}
                        showThumbnails={false}
                        disableArrowKeys={disableKeyboard}
                        forwardedRef={this.setImageGallery}
                        onClick={this.onImageGalleryClick}
                        onSlide={this.onSlide}
                    />

                    {this.state.loading || currentImage.hdSrc || currentImage.canRotate || currentImage.canDelete ? (
                        <div className="album-controls">
                            {this.state.loading ? (
                                <i className="fa fa-spin fa-spinner" />
                            ) : null}

                            {!this.state.loading && currentImage.hdSrc ? (
                                <a href={currentImage.hdSrc} target="_blank" className="image-control-full">
                                    <i className="fa fa-search-plus" />
                                </a>
                            ) : null}

                            {!this.state.loading && (currentImage.canRotate || currentImage.canDelete) ? (
                                <div className="image-controls-actions">
                                    {currentImage.canRotate ? (
                                        <a
                                            href="#"
                                            onClick={this.onRotateLeft}
                                            className={cx('image-tool image-rotate', { admin: isAdmin })}
                                        >
                                            <i className={cx('fa', 'fa-rotate-left', { admin: isAdmin })} />
                                        </a>
                                    ) : null}
                                    {currentImage.canRotate ? (
                                        <a
                                            href="#"
                                            onClick={this.onRotateRight}
                                            className={cx('image-tool image-rotate', { admin: isAdmin })}
                                        >
                                            <i className={cx('fa', 'fa-rotate-right', { admin: isAdmin })} />
                                        </a>
                                    ) : null}
                                    {currentImage.canDelete ? (
                                        <a
                                            href="#"
                                            onClick={this.deleteImage}
                                            className={cx('image-tool image-delete', { admin: isAdmin })}
                                        >
                                            <i className={cx('fa', 'fa-trash', { admin: isAdmin })} />
                                        </a>
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>

                {showEditTitle && currentImage.canEdit ? (
                    <RawForm
                        className="album-image-title-form g-form"
                        onSubmit={this.saveImageTitle}
                        isSubmitting={savingTitle}
                    >
                        <TextField
                            name="title"
                            autofocus
                            autoselect
                            initial={currentImage.title || ''}
                        />
                        <FormControls
                            submitText={SAVE_DESCRIPTION}
                            onCancel={this.onEditCancel}
                        />
                    </RawForm>
                ) : (
                    <div
                        className={cx('album-image-description', { 'blank': !currentImage.title, 'image-title-editable': currentImage.canEdit })}
                        onClick={this.onEditClick}
                    >
                        <Emojify>
                            {currentImage.title ? urlize(currentImage.title, 50) : (currentImage.canEdit && CLICK_HERE_TO_ENTER_DESCRIPTION)}
                        </Emojify>
                    </div>
                )}

                <div className="album-status">
                    <span className="album-status-created">
                        {interpolate(WAS_ADDED_when, { when: timeAt(new Date(currentImage.created * 1000)) })}
                    </span>
                    <span className="sep">
                        &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                    </span>
                    <LikeControl
                        isLikeable={currentImage.likeData.isLikeable}
                        isLikedByMe={currentImage.likeData.isLikedByMe}
                        postUrl={currentImage.likeData.postUrl}
                        onChange={this.onLikeChange}
                    />
                    <LikeSection
                        detailsUrl={currentImage.likeData.detailsUrl}
                        isLikedByMe={currentImage.likeData.isLikedByMe}
                        otherLikesCount={currentImage.likeData.otherLikesCount}
                    />
                    {isAuth ? (
                        <span>
                            &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                            <span dangerouslySetInnerHTML={{__html: complaintdyn.renderControl('icon-gray', currentImage.complaintData)}} />
                            <span dangerouslySetInnerHTML={{__html: complaintdyn.renderPlaceholder(currentImage.complaintData)}} />
                        </span>
                    ) : null}

                    {/* Key is necessary so that we always generate new HTML DOM element */}
                    <span key={'album-status-comments-' + currentImage.id} className="album-status-comments" />
                </div>

                {/* Key is necessary so that we always generate new HTML DOM element */}
                <div key={'album-comments-' + currentImage.id} className="album-comments">
                    {'no-comments' in currentImage.comment2Data ? null : (
                        <Comments
                            postKey={currentImage.comment2Data.ids.join('/')}
                            count={currentImage.comment2Data.count}
                        />
                    )}
                </div>

            </div>
        );
    }

    public resetUrl() {
        this.changeUrlState(this.state.startingUrl);
    }

    private setImageGallery = (r) => this.imageGallery = r;

    private onLikeChange = (data) => this.onLike({
        ...data,
        index: this.state.current,
    });

    private onEditClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const { current, images } = this.state;
        const currentImage = images[current];

        if (currentImage.canEdit && (event.nativeEvent.target as Node).nodeName.toLowerCase() !== 'a') {
            // Only if can edit
            // and when clicked element is not <a> tag
            this.setState({ showEditTitle: true });
        }
    };

    private onEditCancel = () => this.setState({ showEditTitle: false });

    private onRotateLeft = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        this.rotateImage(90);
    };

    private onRotateRight = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        this.rotateImage(270);
    };

    private onImageGalleryClick = () => {
        if (isMqDesktop()) {
            this.imageGallery.slideToIndex((this.imageGallery.getCurrentIndex() + 1) % this.state.images.length);
        }
    };

    private onSlide = (index) => {
        this.setState({ current: index });
        this.changeUrlToIndex(index);
    };

    private changeUrlState = (url, stateObj = {}) => {
        if (!('history' in window) || !('pushState' in window.history)) {
            // No history API support
            return;
        }

        try {
            if (isMqDesktop()) {
                window.history.pushState(stateObj, null, url);
            } else {
                window.history.replaceState(stateObj, null, url);
            }
        } catch (e) {
            window.location.replace(url);
        }
    };

    private changeUrlToIndex = (index) => {
        if (!('history' in window) || !('pushState' in window.history)) {
            // No history API support
            return;
        }

        const {images} = this.props;
        const currentImage = images[this.imageGallery.getCurrentIndex()];

        // Do not place same state twice
        if (!window.history.state || !window.history.state.album || window.history.state.current !== this.imageGallery.getCurrentIndex()) {
            this.changeUrlState(currentImage.url, {
                album: true,
                current: this.imageGallery.getCurrentIndex(),
            });
        }
    };

    private rotateImage = (angle) => {
        this.setState({ loading: true });
        const { current } = this.state;
        const image = this.state.images[this.state.current];
        $.post(photoblog_photo_rotate_url(image.id), { angle }, (data) => { // eslint-disable-line import/namespace
            const images = [
                ...this.state.images.slice(0, current),
                {
                    ...this.state.images[current],
                    bigSrc: data.url,
                    hdSrc: data.hd,
                    smallSrc: data.thumbnail,
                },
                ...this.state.images.slice(0, current + 1),
            ];

            this.setState({
                loading: false,
                images,
            });
        });
    };

    private deleteImage = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        const image = this.state.images[this.state.current];
        const current = this.state.current;
        if (confirm(ARE_YOU_SURE_YOU_WANT_TO_DELETE_PHOTO)) {
            this.setState({ loading: true });
            $.post(photoblog_photo_delete_url(image.id), { notify: 1 }, (msg) => { // eslint-disable-line import/namespace
                // Go to next image
                const newImages = this.state.images.filter((i) => i.id !== image.id);
                this.setState({
                    loading: false,
                    images: newImages,
                    current: current < newImages.length ? current : 0,
                });
                this.imageGallery.slideToIndex(current < newImages.length ? current : 0);
            });
        }
    };

    private saveImageTitle = (values) => {
        this.setState({ savingTitle: true });
        const current = this.state.current;
        const image = this.state.images[current];
        $.post(photoblog_set_image_title_url(image.id), { text: values.title }, (resp) => { // eslint-disable-line import/namespace
            // resp.text might not be same as values.title, because html tags are filtered on server
            const images = [
                ...this.state.images.slice(0, current),
                {
                    ...this.state.images[current],
                    title: resp.text,
                },
                ...this.state.images.slice(0, current + 1),
            ];

            this.setState({
                images,
                savingTitle: false,
                showEditTitle: false,
            });
        });
    };

    private onLike = ({ count, isLikedByMe, index }) => {
        const images = [
            ...this.state.images.slice(0, index),
            {
                ...this.state.images[index],
                likeData: {
                    ...this.state.images[index].likeData,
                    isLikedByMe,
                },
            },
            ...this.state.images.slice(0, index + 1),
        ];

        this.setState({ images });
    };

}
